import { useCallback } from 'react';

import { useEnabledFeatures } from '@/hooks/dataHelpers';
import { toYouTubePrivacyEnhancedUrl } from '@/lib/commonHelpers';

/**
 * Returns a transformer that rewrites YouTube URLs to their Privacy-Enhanced
 * (youtube-nocookie.com/embed) form when the org flag
 * `enable_youtube_embed_with_privacy_enhance_mode` is on. Flag off = pure no-op.
 */
export const useYouTubeEmbedUrl = () => {
  const flags = useEnabledFeatures();
  const enabled = flags?.enable_youtube_embed_with_privacy_enhance_mode;
  return useCallback(
    <T extends string | undefined>(url: T): T =>
      enabled && url ? (toYouTubePrivacyEnhancedUrl(url) as T) : url,
    [enabled]
  );
};
